// Telegram HapticFeedback wrapper — only active for TG builds
const getHaptic = () => (window as any).Telegram?.WebApp?.HapticFeedback;

// Per-category haptic settings (localStorage-based, per-device)
export const hapticSettings = {
    get buttons(): boolean {
        return localStorage.getItem("sio_haptic_buttons") !== "0";
    },
    set buttons(v: boolean) {
        localStorage.setItem("sio_haptic_buttons", v ? "1" : "0");
    },
    get battle(): boolean {
        return localStorage.getItem("sio_haptic_battle") !== "0";
    },
    set battle(v: boolean) {
        localStorage.setItem("sio_haptic_battle", v ? "1" : "0");
    },
};

/** Important action buttons — medium vibration */
export const hapticMedium = () => {
    if (__SOCIAL__ === "tg" && hapticSettings.buttons) getHaptic()?.impactOccurred?.("medium");
};

/** Fighter collision — light vibration, throttled */
let lastBattleHaptic = 0;
export const hapticBattle = () => {
    if (__SOCIAL__ !== "tg" || !hapticSettings.battle) return;
    const now = Date.now();
    if (now - lastBattleHaptic < 200) return;
    lastBattleHaptic = now;
    getHaptic()?.impactOccurred?.("light");
};

/** Settlement capture — heavy vibration */
export const hapticHeavy = () => {
    if (__SOCIAL__ === "tg" && hapticSettings.battle) getHaptic()?.impactOccurred?.("heavy");
};

/** Victory / prize — firework pattern (series of vibrations) */
export const hapticFirework = () => {
    if (__SOCIAL__ !== "tg" || !hapticSettings.battle) return;
    const h = getHaptic();
    if (!h) return;
    h.impactOccurred?.("heavy");
    setTimeout(() => h.impactOccurred?.("medium"), 100);
    setTimeout(() => h.impactOccurred?.("heavy"), 250);
    setTimeout(() => h.notificationOccurred?.("success"), 400);
};
